<template>
  <form @submit.prevent="submit">
    <b-form-group label="Exportadora">
      <b-form-select
        value="Seleccione..."
        :options="customers"
        :state="$v.waybillData.client_customer.$dirty ? !$v.waybillData.client_customer.$error : null"
        v-model="$v.waybillData.client_customer.$model"
      >
      </b-form-select>
    </b-form-group>

    <b-form-group label="Planta">
      <b-form-select
        value="Seleccione..."
        :options="plantOptions"
        :state="$v.waybillData.plant.$dirty ? !$v.waybillData.plant.$error : null"
        v-model="$v.waybillData.plant.$model"
      >
      </b-form-select>
    </b-form-group>

    <b-form-group label="Productor">
      <b-form-select disabled v-if="companies.length === 0"></b-form-select>
      <v-2-select
        ref="company_select"
        v-if="companies.length > 0"
        :options="companies"
        v-model="$v.waybillData.company.$model"
        label="text"
      />
    </b-form-group>

    <b-form-group>
      <label for="waybill_number">Número de guía de despacho</label>
      <b-form-input
        type="text"
        id="waybill_number"
        :state="$v.waybillData.number.$dirty ? !$v.waybillData.number.$error : null"
        v-model="$v.waybillData.number.$model"
        placeholder="ej. 1234"
      ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="waybill_date">Fecha de guía de despacho</label>
      <b-form-datepicker
        placeholder="dd-mm-aaaa"
        locale="es"
        id="waybill_date"
        :state="$v.waybillData.waybill_date.$dirty ? !$v.waybillData.waybill_date.$error : null"
        v-model="$v.waybillData.waybill_date.$model"
      ></b-form-datepicker>
    </b-form-group>

    <b-form-group>
      <label for="name">Nombre del Chofer</label>
      <b-form-input
        type="text"
        id="name"
        :state="$v.waybillData.truck_driver.$dirty ? !$v.waybillData.truck_driver.$error : null"
        v-model="$v.waybillData.truck_driver.$model"
        placeholder="ej. Juan Soto"
      ></b-form-input>
    </b-form-group>

    <b-form-group>
      <label for="name">Patente</label>
      <b-form-input
        type="text"
        id="name"
        :state="$v.waybillData.license_plate.$dirty ? !$v.waybillData.license_plate.$error : null"
        v-model="$v.waybillData.license_plate.$model"
        placeholder="ej. FL9090"
      ></b-form-input>
    </b-form-group>
    <b-form-group>
      <label for="textarea-auto-height">Notas:</label>
      <b-form-textarea
        id="textarea"
        v-model="waybillData.note"
        placeholder="Escriba acá notas relacionadas con la guia de despacho."
        rows="3"
        max-rows="6"
      >
      </b-form-textarea>
    </b-form-group>
  </form>
</template>

<script>
import { required, numeric, minLength, between } from "vuelidate/lib/validators";
import searchSelect from "../reusable/searchSelect";
import V2Select from "../reusable/V2Select";
import miniToastr from "mini-toastr";
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

export default {
  name: "RecepcionForm1",
  components: { searchSelect, V2Select },
  props: ["waybillData"],
  data() {
    return {
      loading: false,
      customers: [{ value: "", text: "Cargando..." }],
      plantOptions: [{ value: "", text: "Cargando..." }],
      companies: []
    };
  },
  validations: {
    waybillData: {
      client_customer: { required },
      company: { required },
      plant: { required },
      number: { required, numeric },
      waybill_date: { required },
      // arrival_datetime: {required},
      truck_driver: { required },
      license_plate: { required }
    }
  },
  watch: {
    "waybillData.client_customer": {
      handler(val) {
        if (val) {
          console.log(val);
          this.getCompanies(val);
        }
      }
    }
  },
  computed: {
    urlSearchClientCustomer: function () {
      return "/api/v1/company/select_search_company/?type=1";
    },
    urlSearchCompany: function () {
      return "/api/v1/company/select_search_company/?type=2&client_customer_id=" + this.waybillData.client_customer.id;
    }
  },
  methods: {
    handleBlur(evt) {
      if (evt == null) {
        this.$refs.client_customer_select.options = [];
        this.waybillData.client_customer = "";

        this.$refs.company_select.options = [];
        this.waybillData.company = "";
      }
    },
    handleBlur2(evt) {
      if (evt == null) {
        this.$refs.company_select.options = [];
        this.waybillData.company = "";
      }
    },
    async getCustomers() {
      const thisV = this;
      thisV.loading = true;
      try {
        const res = await thisV.$axios({
          method: "GET",
          url: "/production/get_customers/",
          headers: {
            "Content-Type": "application/json"
          }
        });
        thisV.loading = false;
        const data = res.data.data;
        const customers = [];
        for (let key in data) {
          const customer = data[key];
          customers.push(customer);
        }
        thisV.customers = customers;
      } catch (error) {
        console.log(error);
        thisV.loading = false;
      }
    },
    async getPlants() {
      const thisV = this;
      thisV.loading = true;
      try {
        const res = await thisV.$axios({
          method: "GET",
          url: "/production/get_plants/",
          headers: {
            "Content-Type": "application/json"
          }
        });
        thisV.loading = false;
        const data = res.data.data;
        const plants = [];
        for (let key in data) {
          const plant = data[key];
          plants.push(plant);
        }
        thisV.plantOptions = plants;
      } catch (error) {
        console.log(error);
        thisV.loading = false;
      }
    },
    async getCompanies(e) {
      const thisV = this;
      thisV.companies = [{ value: "", text: "Cargando..." }];
      thisV.loading = true;
      try {
        const res = await thisV.$axios({
          method: "GET",
          url: `/production/get_companies/${e}/`,
          headers: {
            "Content-Type": "application/json"
          }
        });
        thisV.loading = false;
        const data = res.data.data;
        const companies = [];
        for (let key in data) {
          const company = data[key];
          company["text"] = data[key]["number"] + " - " + data[key]["text"];
          companies.push(company);
        }
        thisV.companies = companies;
      } catch (error) {
        console.log(error);
        thisV.loading = false;
      }
    },
    // Validation methods
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        // do your submit logic here
        this.$emit("validate", true);
      }
    }
  },
  mounted() {
    this.getCustomers();
    this.getPlants();
    const that = this;
    window.setTimeout(function () {
      that.$refs.client_customer_select.selected = that.waybillData.client_customer;
    }, 2000);
    window.setTimeout(function () {
      that.$refs.company_select.selected = that.waybillData.company;
    }, 2000);
  },
  beforeMount() {
    //this.getCustomers();
  }
};
</script>

<style scoped></style>
